  <mat-form-field #formFieldContainer floatLabel="always" appearance="none" class="sc-radio-list">
      <mat-label
        #labelContainer  (click)="toggleTooltip(tooltip)"
        class="{{componentDefinition?.mandatory ? 'mandatory' : ''}} ">
        {{componentDefinition?.label}}
      </mat-label>
      <div class="labelToolTipContainer"
        #tooltip="matTooltip"
        matTooltip="{{componentDefinition.label}}"
        [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
      </div>
      <input matInput [hidden]="true"
            [id]="componentDefinition?.name" [name]="componentDefinition?.name"
            />






      <input matInput hidden [required]="isRequired"
            (ngModelChange)="valueChanged($event)"
            [(ngModel)]="document[fieldName]">

      <div [formGroup]="optionFormGroup">

        <mat-radio-group aria-labelledby="radio-group-label"
                          formControlName="formControlRadio"  >
            <mat-radio-button class="radiolist-wrap" [ngClass]="radioItemColumnClass" *ngFor="let quesOption of componentDefinition?.radioList"
                              [title]="quesOption"
                              [value]="quesOption" [disabled]="disabled" color="primary">
              {{quesOption}}
            </mat-radio-button>
          </mat-radio-group>
      </div>
</mat-form-field>
<ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
